export default "__VITE_ASSET__174775d4__"